import React from'react';
import Papa from 'papaparse';

const DownloadButton = ({ data, columns }) => {
  const csvData = Papa.unparse({
    fields: columns,
    data: data,
  });

  const fileName = 'my-data-table.csv';

  const handleClick = () => {
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.target = '_blank';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button style={{marginLeft:"5px", marginBottom:"5px"}} className="btn btn-success" onClick={handleClick}>Download CSV</button>
  );
};

export default DownloadButton;

